import { faFlag } from "@fortawesome/pro-regular-svg-icons"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ListItemIcon, MenuItem, Typography } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import Menu from "@mui/material/Menu"
import { languageSVC, translate } from "app/language/service"
import { messageSVC } from "message/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { userSVC } from "user/service"

export const LocalesPopupMenu = () => {
  const [anchorElement, setAnchorElement] = React.useState<null | HTMLElement>(null)
  const handleClose = () => setAnchorElement(null)
  const locales = languageSVC.getLocales()
  const currentLocale = languageSVC.getLocale()
  return (
    <FlexBox
      className="locales-menu"
      sx={{
        "position": "relative",
        "&:hover *": {
          color: theme => theme.palette.primary.main
        }
      }}>
      <IconButton
        id="locales-menu-button"
        color="primary"
        aria-label="more"
        aria-controls="locales-menu"
        aria-haspopup="true"
        sx={{
          "p": 0,
          "& .icon": {
            fontSize: "1.75rem",
            color: theme => theme.palette.text.primary2,
            transition: "all 300ms ease"
          }
        }}
        onClick={(event: any) => setAnchorElement(event.currentTarget)}>
        <FontAwesomeIcon icon={faFlag} className="icon" />
      </IconButton>
      <Typography
        fontSize=".8rem"
        sx={{
          color: theme => theme.palette.text.primary2,
          cursor: "pointer",
          transition: "all 300ms ease",
          position: "absolute",
          left: 0,
          right: 0,
          ml: "auto",
          mr: "auto",
          width: "1.4rem",
          borderRadius: "1rem",
          top: ".4rem",
          textAlign: "center",
          p: ".2rem"
        }}
        onClick={(event: any) => setAnchorElement(event.currentTarget)}>
        {currentLocale.toUpperCase()}
      </Typography>
      <Menu
        id="locales-menu"
        open={Boolean(anchorElement)}
        anchorEl={anchorElement}
        onClose={() => handleClose()}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        variant="menu">
        {locales.map((locale, index) => (
          <MenuItem
            id={`language-menu-item-${locale}`}
            sx={{ paddingLeft: ".5rem" }}
            key={`locales-menu-item-${index}`}
            selected={currentLocale === locale}
            onClick={() => {
              if (locale !== currentLocale) {
                if (userSVC.isLoggedIn()) {
                  messageSVC.confirmMessage({
                    message: [
                      translate("user.change.local.warning", undefined, locale),
                      translate("label.continue.confirmation", undefined, locale)
                    ],
                    title: translate("user.change.local.title", undefined, locale),
                    locale,
                    onSuccess: () => languageSVC.setLocale(locale)
                  })
                } else {
                  languageSVC.setLocale(locale)
                }
              }
              handleClose()
            }}>
            <ListItemIcon sx={{ minWidth: "1.5rem" }}>
              {currentLocale === locale && <FontAwesomeIcon icon={faCheck} />}
            </ListItemIcon>
            {translate(`user.locale.${locale}`, undefined, locale)}
          </MenuItem>
        ))}
      </Menu>
    </FlexBox>
  )
}
